/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateEmailResponse
 */
export interface GenerateEmailResponse {
    /**
     * returns the distribution request id - unique key to identify the email in PCD
     * @type {string}
     * @memberof GenerateEmailResponse
     */
    distributionRequestId?: string;
    /**
     * the id of the current user
     * @type {string}
     * @memberof GenerateEmailResponse
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateEmailResponse
     */
    partnerUid?: string;
}

/**
 * Check if a given object implements the GenerateEmailResponse interface.
 */
export function instanceOfGenerateEmailResponse(value: object): value is GenerateEmailResponse {
    return true;
}

export function GenerateEmailResponseFromJSON(json: any): GenerateEmailResponse {
    return GenerateEmailResponseFromJSONTyped(json, false);
}

export function GenerateEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'distributionRequestId': json['distributionRequestId'] == null ? undefined : json['distributionRequestId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'partnerUid': json['partnerUid'] == null ? undefined : json['partnerUid'],
    };
}

export function GenerateEmailResponseToJSON(json: any): GenerateEmailResponse {
    return GenerateEmailResponseToJSONTyped(json, false);
}

export function GenerateEmailResponseToJSONTyped(value?: GenerateEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'distributionRequestId': value['distributionRequestId'],
        'userId': value['userId'],
        'partnerUid': value['partnerUid'],
    };
}

